export enum ApprovalStatus {
  pending = "pending",
  approved = "approved",
  rejected = "rejected"
}

export const approvalStatusEnumValues = [
  ApprovalStatus.pending,
  ApprovalStatus.approved,
  ApprovalStatus.rejected
];
